import { SetStateAction, WritableAtom } from 'jotai';
import { initHints } from './utils/hintsFactory';

const STORAGE_VERSION = 'v1';
const STORAGE_NAME = `sim-products`;

const INITIAL_VALUES = {
  accounts: [],
  productCodes: [],
  tags: [],
  connectionId: [],
  orderNumber: [],
  mobileNetworkOperator: [],
  customFields: {},
} as {
  accounts: string[];
  productCodes: any[];
  tags: any[];
  connectionId: any[];
  orderNumber: any[];
  mobileNetworkOperator: any[];
  customFields: Record<string, string[]>;
};
//#TODO: fix types

const { storageAtom, syncAtom, updateAllAtom, gettersAndRemovers } = initHints({
  storageName: STORAGE_NAME,
  storageVersion: STORAGE_VERSION,
  initialValues: INITIAL_VALUES,
});

const {
  accounts,
  productCodes,
  tags,
  connectionId,
  orderNumber,
  mobileNetworkOperator,
  customFields,
} = gettersAndRemovers;

export const atomWithStorage = storageAtom;
export const syncHintsAtom = syncAtom;
export const updateHintsAtom = updateAllAtom;
export const connectionIdHintsAtom = connectionId;
export const orderNumberHintsAtom = orderNumber;
export const tagsHintsAtom = tags;
export const accountsHintsAtom = accounts as WritableAtom<string[], [SetStateAction<any>], void>;
export const productCodesHintsAtom = productCodes as WritableAtom<
  string[],
  [SetStateAction<any>],
  void
>;
export const customFieldsHintsAtom = customFields;
export const mnoHintsAtom = mobileNetworkOperator;
